module.exports = __webpack_public_path__ + "img/rechazoCD.f104fe45.svg";